import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Login from "components/Structure/Login/Login.js";
import useSuspendedUser from "hooks/useSuspendedUser.ts";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useMail } from "contexts/mailContext/mailContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

const TooltipConditionWrapper = ({ children }) => {
  const { isLoggedIn } = useUser();
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const handleLoginClick = () => {
    setModal({
      modal: Login,
      modalSize: "full-modal",
    });
  };

  return isLoggedIn() ? (
    children
  ) : (
    <Tooltip
      tooltipText={
        <div className="tooltip-with-action">
          {getTextByKey("reupload-tooltip-login-only")}
          <div onClick={handleLoginClick}>{getTextByKey("login")}</div>
        </div>
      }
      delay={0}
      clickable={true}
    >
      {children}
    </Tooltip>
  );
};

export const ReuploadAction = ({ mailId }) => {
  const { setReuploadingMail, getReuploadingMail } = useMail();
  const { getTextByKey } = useContent();
  const { isLoggedIn } = useUser();
  const { isUserSuspended } = useSuspendedUser();
  const { addToast } = useToasts();

  const handleClick = () => {
    if (isUserSuspended) {
      addToast(getTextByKey("suspended-user-toast"), {
        appearance: "error",
      });
      return;
    }

    if (!isLoggedIn()) {
      return;
    }
    if (
      getReuploadingMail() === mailId &&
      document
        .getElementById("reupload-component")
        ?.classList.contains("minimized")
    ) {
      document
        .getElementById("reupload-component")
        .querySelector(".maximize")
        ?.click();
    }
    setReuploadingMail(mailId);

    // close the upload complete sidebar
    const closeButton = document.getElementById("close-sidebar-button");
    if (closeButton) {
      closeButton.click();
    }
  };

  return (
    <TooltipConditionWrapper>
      <Button
        className="reuploader-action-button"
        onClick={handleClick}
        disabled={!isLoggedIn()}
      >
        <Icon name="cloud-upload" blue clickable />
        {getTextByKey("upload-more-files-text")}
      </Button>
    </TooltipConditionWrapper>
  );
};
